<template>
  <div>
    <v-progress-linear v-if="loadingCharts" indeterminate color="primary" class="mb-4"></v-progress-linear>

    <v-card class="mb-4">
      <v-card-title class="report-card-title">
        <h2>{{ dayChart.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(dayChart, 'day')"
          :on-download="downloadDayChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !dayChart.categories.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="chartOptions(dayChart)"
          :series="dayChart.series"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!dayChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.week">
      <v-card-title class="report-card-title">
        <h2>{{ weekChart.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(weekChart, 'week')"
          :on-download="downloadWeekChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !weekChart.categories.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="chartOptions(weekChart)"
          :series="weekChart.series"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!weekChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.month">
      <v-card-title class="report-card-title">
        <h2>{{ monthChart.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(monthChart, 'month')"
          :on-download="downloadMonthChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !monthChart.categories.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="chartOptions(monthChart)"
          :series="monthChart.series"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!monthChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.year">
      <v-card-title class="report-card-title">
        <h2>{{ yearChart.title }}</h2>
        <download-button
          label="CSV Download"
          download-type="text/csv;charset=utf-8"
          :file-name="buildChartCsvFileName(yearChart, 'year')"
          :on-download="downloadYearChartCsv"
          :button-attributes="{ small: true, color: 'primary', outline: true }"
          :disabled="loadingCharts || !yearChart.categories.length"
        ></download-button>
      </v-card-title>
      <v-card-text>
        <st-apexchart
          type="bar"
          height="320"
          :options="chartOptions(yearChart)"
          :series="yearChart.series"
          :show-download-button="false"
        ></st-apexchart>
        <div v-if="!yearChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import src from './src'
export default src
</script>

<style scoped>
.report-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
</style>
